// Tiny Wonders Pick - Soft, Sweet Baby Essentials & Newborn Layette

// ============================================
// SITE IMAGES
// ============================================
export const siteImages = {
  heroMain: '/images/Little_Me_Baby_Essentials_Gown_1.jpg',
  heroSecondary: '/images/Little_Me_Baby_Footies_2.png',
  heroLifestyle: '/images/Little_Me_Baby_Sleeper_Gowns.png',
  ctaBackground: '/images/187_250318_LittleMe_011.jpg',
  featuredBackground: '/images/NEW_Better_than_Bamboo.png',
  powerBackground: '/images/NEW_Better_than_Bamboo.png',
  shopBanner: '/images/Little_Me_Baby_Essentials_Gown_1.jpg',
  aboutBanner: '/images/Little_Me_Baby_Sleeper_Gowns.png',
  contactBanner: '/images/Little_Me_Baby_Footies_2.png',
  returnsBanner: '/images/Little_Me_Baby_Bodysuits_1.png',
  privacyBanner: '/images/Little_Me_Sweaters_and_Sets_2.png',
  ageBoy: '/images/LM_Baby_Boy_Clothing.png',
  ageGirl: '/images/Little_Me_Baby_Dresses_2.png',
  ageToddler: '/images/LM_Toddler_Kids.png',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 65;

export const CARD_DESCRIPTOR = 'TINY WONDERS PICK';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(833) 633-9513',
  email: 'contactus@tinywonderspick.com',
  corpName: 'Radan Capital Management LLC',
  domain: 'tinywonderspick.com',
  brandName: 'Tiny Wonders Pick',
  address: {
    street: '547 E Altgeld Ave',
    city: 'Glendale Heights',
    state: 'IL',
    zip: '60139',
    country: 'United States'
  }
};

// Return address — DO NOT CHANGE
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// PRODUCTS — Baby essentials & newborn layette
// Prices restricted to the approved set only
// ============================================
export const products = [
  // ---------- FOOTIES & ONE-PIECES ----------
  {
    id: 'vintage-rose-footed-one-piece',
    name: 'Vintage Rose Footed One-Piece & Hat',
    slug: 'vintage-rose-footed-one-piece',
    sku: 'TWP-FT-001',
    price: 17.49,
    image: '/images/Little_Me_Cute_Vintage_Rose_Footie.png',
    badge: 'Bestseller',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'A buttery-soft cotton footie covered in a delicate vintage rose print, paired with a matching knot hat for those first sweet snapshots.',
    keyBenefits: ['Made from 100% breathable cotton', 'Full-length zipper for easy changes', 'Comes with a coordinating baby hat'],
    usage: 'Machine wash cold with like colors, tumble dry low. Wash before first wear for the softest feel against baby skin.',
    features: ['100% Cotton', 'Footed', 'Zip Closure', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'giraffe-footed-one-piece',
    name: 'Giraffe Footed One-Piece & Hat',
    slug: 'giraffe-footed-one-piece',
    sku: 'TWP-FT-002',
    price: 17.49,
    image: '/images/colleen.hyland.jpg',
    badge: 'Bestseller',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'A playful all-over giraffe print footie with built-in feet to keep tiny toes cozy, finished with an adorable matching cap.',
    keyBenefits: ['Soft, gentle cotton knit', 'Covered feet for all-day warmth', 'Matching hat included'],
    usage: 'Machine wash cold, tumble dry low. Snap and zip closures make diaper changes quick and fuss-free.',
    features: ['100% Cotton', 'Footed', 'Snap Closure', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'frog-friends-footed-one-piece',
    name: 'Frog Friends Footed One-Piece',
    slug: 'frog-friends-footed-one-piece',
    sku: 'TWP-FT-003',
    price: 17.49,
    image: '/images/L657311_L696_1.jpg',
    badge: 'New',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'Cheerful little frogs hop across this cozy footed one-piece, designed with a two-way zipper to make late-night changes a breeze.',
    keyBenefits: ['Two-way zipper from neck to toe', 'Tagless neckline for comfort', 'Soft, durable cotton blend'],
    usage: 'Machine wash cold inside out, tumble dry low. Avoid bleach to keep the print bright.',
    features: ['Cotton Blend', 'Footed', '2-Way Zip', 'Tagless'],
    inStock: true,
  },
  {
    id: 'baby-bunnies-footed-one-piece',
    name: 'Baby Bunnies Footed One-Piece & Hat',
    slug: 'baby-bunnies-footed-one-piece',
    sku: 'TWP-FT-004',
    price: 17.98,
    image: '/images/LittleMeBabyBunniesFootie.png',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'Sweet bunnies scattered across a soft pastel footie, complete with a matching hat for snuggly nap-time and beyond.',
    keyBenefits: ['Gentle, skin-soft cotton', 'Footed design keeps toes warm', 'Includes a coordinating hat'],
    usage: 'Machine wash cold, tumble dry low. Wash before first use for maximum softness.',
    features: ['100% Cotton', 'Footed', 'Snap Closure', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'puppy-toile-footed-one-piece',
    name: 'Puppy Toile Footed One-Piece & Hat',
    slug: 'puppy-toile-footed-one-piece',
    sku: 'TWP-FT-005',
    price: 17.98,
    image: '/images/Puppy_Toile_Footed_One-Piece_And_Hat.png',
    badge: 'Bestseller',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'A timeless puppy toile print on a cozy footed one-piece with a matching hat — classic charm for everyday cuddles.',
    keyBenefits: ['Breathable cotton knit', 'Easy full-length zipper', 'Matching hat included'],
    usage: 'Machine wash cold with like colors, tumble dry low.',
    features: ['100% Cotton', 'Footed', 'Zip Closure', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'petite-rose-footed-one-piece',
    name: 'Petite Rose Footed One-Piece & Hat',
    slug: 'petite-rose-footed-one-piece',
    sku: 'TWP-FT-006',
    price: 17.49,
    image: '/images/LittleMeBabyPetiteRoses.png',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'Tiny roses bloom across this gentle footie, paired with a sweet matching hat for a picture-perfect newborn look.',
    keyBenefits: ['100% soft cotton', 'Covered feet for cozy comfort', 'Coordinating hat included'],
    usage: 'Machine wash cold, tumble dry low. Do not iron the print.',
    features: ['100% Cotton', 'Footed', 'Snap Closure', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'cute-bear-footed-one-piece',
    name: 'Cute Bear Footed One-Piece',
    slug: 'cute-bear-footed-one-piece',
    sku: 'TWP-FT-007',
    price: 17.49,
    image: '/images/Little_Me_Blue_Cute_Bear.png',
    badge: 'New',
    categoryId: 'footies',
    categorySlug: 'footies',
    description: 'Friendly little bears on a soft blue footie with a two-way zipper that makes diaper duty simple, day or night.',
    keyBenefits: ['Two-way zipper for fast changes', 'Soft, stretchy cotton blend', 'Tagless for irritation-free comfort'],
    usage: 'Machine wash cold inside out, tumble dry low.',
    features: ['Cotton Blend', 'Footed', '2-Way Zip', 'Tagless'],
    inStock: true,
  },

  // ---------- SLEEPER GOWNS ----------
  {
    id: 'little-ducks-sleeper-gown',
    name: 'Little Ducks Sleeper Gown & Hat',
    slug: 'little-ducks-sleeper-gown',
    sku: 'TWP-SG-001',
    price: 17.98,
    image: '/images/LBQ07042N_L798_1.jpg',
    badge: 'Bestseller',
    categoryId: 'gowns',
    categorySlug: 'gowns',
    description: 'A cozy sleeper gown printed with cheerful little ducks and an easy elastic hem for the simplest middle-of-the-night changes.',
    keyBenefits: ['Open hem for quick diaper changes', 'Soft cotton for restful sleep', 'Matching hat included'],
    usage: 'Machine wash cold, tumble dry low. Wash before first wear.',
    features: ['100% Cotton', 'Sleeper Gown', 'Elastic Hem', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'thank-heaven-boys-sleeper-gown',
    name: 'Thank Heaven Sleeper Gown & Hat',
    slug: 'thank-heaven-boys-sleeper-gown',
    sku: 'TWP-SG-002',
    price: 17.98,
    image: '/images/LBQ01664N_L456_1.jpg',
    categoryId: 'gowns',
    categorySlug: 'gowns',
    description: 'A heartfelt keepsake gown with a soft sentiment print and matching hat, perfect for welcoming your little one home.',
    keyBenefits: ['Gentle cotton against newborn skin', 'Easy open-bottom design', 'Coordinating hat included'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['100% Cotton', 'Sleeper Gown', 'Open Bottom', 'Includes Hat'],
    inStock: true,
  },
  {
    id: 'vintage-rose-sleeper-gown',
    name: 'Vintage Rose Sleeper Gown & Hat',
    slug: 'vintage-rose-sleeper-gown',
    sku: 'TWP-SG-003',
    price: 17.98,
    image: '/images/L654324_L141_1.jpg',
    categoryId: 'gowns',
    categorySlug: 'gowns',
    description: 'Our signature vintage rose print on a dreamy sleeper gown with a matching hat — soft, sweet and made for cuddles.',
    keyBenefits: ['100% breathable cotton', 'Convenient open hem', 'Matching hat included'],
    usage: 'Machine wash cold with like colors, tumble dry low.',
    features: ['100% Cotton', 'Sleeper Gown', 'Elastic Hem', 'Includes Hat'],
    inStock: true,
  },

  // ---------- BODYSUITS & BIBS ----------
  {
    id: 'little-ducks-3-pack-bodysuits',
    name: 'Little Ducks 3-Pack Bodysuits',
    slug: 'little-ducks-3-pack-bodysuits',
    sku: 'TWP-BS-001',
    price: 26.97,
    image: '/images/LB807041N_L799_1.jpg',
    badge: 'Value Pack',
    categoryId: 'bodysuits',
    categorySlug: 'bodysuits',
    description: 'A three-pack of soft cotton bodysuits in coordinating duck prints and solids — everyday essentials that mix and match with everything.',
    keyBenefits: ['Set of three bodysuits', 'Lap-shoulder neckline for easy dressing', 'Three-snap bottom for quick changes'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['100% Cotton', '3-Pack', 'Lap Shoulder', 'Snap Closure'],
    inStock: true,
  },
  {
    id: 'puppy-toile-bib-burp-set',
    name: 'Puppy Toile Bib & Burp Set',
    slug: 'puppy-toile-bib-burp-set',
    sku: 'TWP-BB-002',
    price: 11.49,
    image: '/images/LB404532N_L190_1.jpg',
    categoryId: 'bodysuits',
    categorySlug: 'bodysuits',
    description: 'A matching bib and burp cloth set in our classic puppy toile print — soft, absorbent and ready for every feeding.',
    keyBenefits: ['Absorbent cotton terry backing', 'Adjustable snap closure on bib', 'Coordinating burp cloth included'],
    usage: 'Machine wash warm, tumble dry low. Pre-wash to boost absorbency.',
    features: ['Cotton', 'Bib + Burp Cloth', 'Snap Closure', 'Absorbent'],
    inStock: true,
  },
  {
    id: 'giraffe-bib-burp-set',
    name: 'Giraffe Bib & Burp Set',
    slug: 'giraffe-bib-burp-set',
    sku: 'TWP-BB-003',
    price: 11.49,
    image: '/images/LB404054N_L110_1.jpg',
    categoryId: 'bodysuits',
    categorySlug: 'bodysuits',
    description: 'A cheerful giraffe bib and burp cloth duo that keeps mealtimes tidy while looking irresistibly cute.',
    keyBenefits: ['Soft terry-lined for absorbency', 'Easy-snap adjustable bib', 'Matching burp cloth'],
    usage: 'Machine wash warm, tumble dry low.',
    features: ['Cotton', 'Bib + Burp Cloth', 'Snap Closure', 'Absorbent'],
    inStock: true,
  },
  {
    id: 'sailboats-bib-burp-set',
    name: 'Sailboats Bib & Burp Set',
    slug: 'sailboats-bib-burp-set',
    sku: 'TWP-BB-004',
    price: 8.99,
    image: '/images/LB405383N_L479_1.jpg',
    badge: 'Sale',
    categoryId: 'bodysuits',
    categorySlug: 'bodysuits',
    description: 'Set sail at snack time with this nautical bib and burp cloth set — soft, absorbent and perfectly pint-sized.',
    keyBenefits: ['Gentle, absorbent cotton', 'Snap-adjustable bib fit', 'Burp cloth included'],
    usage: 'Machine wash warm, tumble dry low.',
    features: ['Cotton', 'Bib + Burp Cloth', 'Snap Closure', 'Absorbent'],
    inStock: true,
  },

  // ---------- BLANKETS ----------
  {
    id: 'giraffe-receiving-blanket',
    name: 'Giraffe Receiving Blanket',
    slug: 'giraffe-receiving-blanket',
    sku: 'TWP-BL-001',
    price: 17.49,
    image: '/images/L843890_L150_1.jpg',
    badge: 'Bestseller',
    categoryId: 'blankets',
    categorySlug: 'blankets',
    description: 'A generously sized cotton receiving blanket in our beloved giraffe print — perfect for swaddling, tummy time and on-the-go.',
    keyBenefits: ['Soft, breathable cotton', 'Roomy size for swaddling', 'Lightweight and packable'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['100% Cotton', 'Receiving Blanket', 'Swaddle Size', 'Lightweight'],
    inStock: true,
  },
  {
    id: 'vintage-rose-receiving-blanket',
    name: 'Vintage Rose Receiving Blanket',
    slug: 'vintage-rose-receiving-blanket',
    sku: 'TWP-BL-002',
    price: 17.49,
    image: '/images/L853888_L141_1_f4bec6d7-dff1-4c07-aa1b-56e6f643ec2b.jpg',
    categoryId: 'blankets',
    categorySlug: 'blankets',
    description: 'Wrap your little one in our signature vintage rose print — a soft cotton receiving blanket made for snuggles and keepsakes.',
    keyBenefits: ['Gentle cotton weave', 'Ideal for swaddling or stroller', 'Coordinates with our footies'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['100% Cotton', 'Receiving Blanket', 'Swaddle Size', 'Lightweight'],
    inStock: true,
  },
  {
    id: 'pink-plush-receiving-blanket',
    name: 'Pink Plush Receiving Blanket',
    slug: 'pink-plush-receiving-blanket',
    sku: 'TWP-BL-003',
    price: 26.97,
    image: '/images/L520720_L688_1.jpg',
    badge: 'Cozy',
    categoryId: 'blankets',
    categorySlug: 'blankets',
    description: 'An ultra-plush pink blanket with a velvety-soft pile that feels like a cloud — the coziest cuddle for nap time.',
    keyBenefits: ['Luxuriously plush, fluffy feel', 'Warm yet breathable', 'Stroller and crib friendly'],
    usage: 'Machine wash cold, tumble dry low. Do not iron.',
    features: ['Plush', 'Receiving Blanket', 'Extra Soft', 'Cozy Warmth'],
    inStock: true,
  },
  {
    id: 'white-cable-knit-receiving-blanket',
    name: 'White Cable Knit Receiving Blanket',
    slug: 'white-cable-knit-receiving-blanket',
    sku: 'TWP-BL-004',
    price: 35.96,
    image: '/images/LL701728N_L110_1.jpg',
    badge: 'Heirloom',
    categoryId: 'blankets',
    categorySlug: 'blankets',
    description: 'A classic white cable knit blanket with timeless texture — a beautiful keepsake for newborn photos and gifting.',
    keyBenefits: ['Soft heirloom-quality knit', 'Neutral white suits any nursery', 'Makes a treasured gift'],
    usage: 'Machine wash cold gentle, lay flat to dry to keep its shape.',
    features: ['Cable Knit', 'Receiving Blanket', 'Heirloom', 'Gender Neutral'],
    inStock: true,
  },
  {
    id: 'blue-textured-receiving-blanket',
    name: 'Blue Textured Receiving Blanket',
    slug: 'blue-textured-receiving-blanket',
    sku: 'TWP-BL-005',
    price: 34.98,
    image: '/images/LL704876N_L172_1.jpg',
    categoryId: 'blankets',
    categorySlug: 'blankets',
    description: 'A soft blue blanket with a subtle waffle texture — light, breathable and endlessly snuggly for everyday use.',
    keyBenefits: ['Gentle textured knit', 'Breathable and lightweight', 'Perfect for crib or car seat'],
    usage: 'Machine wash cold gentle, lay flat to dry.',
    features: ['Textured Knit', 'Receiving Blanket', 'Breathable', 'Lightweight'],
    inStock: true,
  },
  {
    id: 'cuddles-2-pack-receiving-blankets',
    name: 'Cuddles Receiving Blankets (2-Pack)',
    slug: 'cuddles-2-pack-receiving-blankets',
    sku: 'TWP-BL-006',
    price: 26.97,
    image: '/images/LL714724N_L457_1.jpg',
    badge: 'Value Pack',
    categoryId: 'blankets',
    categorySlug: 'blankets',
    description: 'Two coordinating soft blankets in one set — keep one in the nursery and one in the diaper bag for cuddles anywhere.',
    keyBenefits: ['Set of two blankets', 'Soft, breathable knit', 'Great everyday value'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['2-Pack', 'Receiving Blanket', 'Soft Knit', 'Everyday'],
    inStock: true,
  },

  // ---------- GIFT SETS ----------
  {
    id: 'pink-cable-sweater-blanket-gift-box',
    name: 'Pink Cable Sweater & Blanket Gift Box',
    slug: 'pink-cable-sweater-blanket-gift-box',
    sku: 'TWP-GS-001',
    price: 69.96,
    image: '/images/LLO16903M_L677_2.jpg',
    badge: 'Gift Set',
    categoryId: 'gifts',
    categorySlug: 'gifts',
    description: 'A pink cable knit sweater and matching blanket presented in a keepsake gift box — a thoughtful welcome for a baby girl.',
    keyBenefits: ['Coordinating sweater and blanket', 'Arrives in a ready-to-give box', 'Soft heirloom cable knit'],
    usage: 'Machine wash cold gentle, lay flat to dry.',
    features: ['Gift Box', 'Sweater + Blanket', 'Cable Knit', 'Keepsake'],
    inStock: true,
  },
  {
    id: 'blue-cable-sweater-blanket-gift-box',
    name: 'Blue Cable Sweater & Blanket Gift Box',
    slug: 'blue-cable-sweater-blanket-gift-box',
    sku: 'TWP-GS-002',
    price: 69.96,
    image: '/images/LLO16901M_L454_2.jpg',
    badge: 'Gift Set',
    categoryId: 'gifts',
    categorySlug: 'gifts',
    description: 'A blue cable knit sweater and matching blanket in a beautiful keepsake box — the perfect gift for a new baby boy.',
    keyBenefits: ['Coordinating sweater and blanket', 'Ready-to-gift presentation box', 'Cozy heirloom cable knit'],
    usage: 'Machine wash cold gentle, lay flat to dry.',
    features: ['Gift Box', 'Sweater + Blanket', 'Cable Knit', 'Keepsake'],
    inStock: true,
  },
  {
    id: 'white-cable-sweater-blanket-gift-box',
    name: 'White Cable Sweater & Blanket Gift Box',
    slug: 'white-cable-sweater-blanket-gift-box',
    sku: 'TWP-GS-003',
    price: 52.47,
    image: '/images/LLO16902M_L110_2.jpg',
    badge: 'Gift Set',
    categoryId: 'gifts',
    categorySlug: 'gifts',
    description: 'A gender-neutral white cable sweater and matching blanket gift box — a timeless way to celebrate any new arrival.',
    keyBenefits: ['Coordinating sweater and blanket', 'Neutral white for any nursery', 'Lovely keepsake gift box'],
    usage: 'Machine wash cold gentle, lay flat to dry.',
    features: ['Gift Box', 'Sweater + Blanket', 'Cable Knit', 'Gender Neutral'],
    inStock: true,
  },
  {
    id: 'newborn-layette-gift-bundle',
    name: 'Newborn Layette Gift Bundle',
    slug: 'newborn-layette-gift-bundle',
    sku: 'TWP-GS-004',
    price: 120.08,
    image: '/images/Little_Me_Puppy_Toile_Newborn_Gown_Blanket.png',
    badge: 'Bundle',
    categoryId: 'gifts',
    categorySlug: 'gifts',
    description: 'A curated newborn layette featuring a footie, sleeper gown, receiving blanket and matching hat — everything for those first weeks home.',
    keyBenefits: ['Complete coming-home essentials', 'Coordinated print throughout', 'Beautifully boxed for gifting'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['Multi-Piece Bundle', 'Newborn Layette', 'Coordinated', 'Gift Ready'],
    inStock: true,
  },
  {
    id: 'deluxe-welcome-baby-bundle',
    name: 'Deluxe Welcome Baby Bundle',
    slug: 'deluxe-welcome-baby-bundle',
    sku: 'TWP-GS-005',
    price: 213.32,
    image: '/images/Little_Me_Baby_Essentials_Gown_1.jpg',
    badge: 'Premium',
    categoryId: 'gifts',
    categorySlug: 'gifts',
    description: 'Our generous welcome bundle pairs footies, gowns, bodysuits, bibs and a cozy blanket — a complete wardrobe for newborn days.',
    keyBenefits: ['Full newborn starter wardrobe', 'Soft cotton head to toe', 'Exclusive bundle savings'],
    usage: 'Machine wash cold, tumble dry low.',
    features: ['Premium Bundle', 'Starter Wardrobe', 'Best Value', 'Gift Ready'],
    inStock: true,
  },
  {
    id: 'ultimate-nursery-keepsake-set',
    name: 'Ultimate Nursery Keepsake Set',
    slug: 'ultimate-nursery-keepsake-set',
    sku: 'TWP-GS-006',
    price: 239.94,
    image: '/images/187_250318_LittleMe_011.jpg',
    badge: 'Limited',
    categoryId: 'gifts',
    categorySlug: 'gifts',
    description: 'Our most luxurious collection — heirloom blankets, cable knit sweater, footies and keepsake accessories in elegant gift packaging.',
    keyBenefits: ['Our most complete gift set', 'Heirloom-quality pieces', 'Luxury keepsake packaging'],
    usage: 'Follow individual care labels. Hand-wash knit pieces for longest life.',
    features: ['Luxury Set', 'Heirloom Pieces', 'Keepsake Box', 'Limited Edition'],
    inStock: true,
  },
];

// ============================================
// CATEGORIES
// ============================================
export const categories = [
  {
    id: 'footies',
    name: 'Footies & One-Pieces',
    slug: 'footies',
    description: 'Cozy footed one-pieces in playful prints to keep little toes warm',
    image: '/images/Little_Me_Baby_Footies_2.png',
    productCount: 7,
  },
  {
    id: 'gowns',
    name: 'Sleeper Gowns',
    slug: 'gowns',
    description: 'Soft sleeper gowns made for easy changes and restful nights',
    image: '/images/Little_Me_Baby_Sleeper_Gowns.png',
    productCount: 3,
  },
  {
    id: 'bodysuits',
    name: 'Bodysuits & Bibs',
    slug: 'bodysuits',
    description: 'Everyday bodysuits and absorbent bib sets for feeding and play',
    image: '/images/Little_Me_Baby_Bodysuits_1.png',
    productCount: 4,
  },
  {
    id: 'blankets',
    name: 'Blankets',
    slug: 'blankets',
    description: 'Soft receiving blankets and plush knits for swaddling and snuggles',
    image: '/images/Little_Me_Sweaters_and_Sets_2.png',
    productCount: 6,
  },
  {
    id: 'gifts',
    name: 'Gift Sets',
    slug: 'gifts',
    description: 'Beautifully boxed bundles and keepsakes for every new arrival',
    image: '/images/LLO16903M_L677_2.jpg',
    productCount: 6,
  },
];

// ============================================
// FEATURES / BENEFITS / STEPS
// ============================================
export const features = [
  { id: 1, title: 'Softest Cotton', description: 'Gentle, breathable fabrics chosen with delicate baby skin in mind' },
  { id: 2, title: 'Free USA Shipping', description: 'Free shipping on every order over $65 within the USA' },
  { id: 3, title: '30-Day Returns', description: 'Changed your mind? Easy, no-fuss returns within 30 days' },
  { id: 4, title: 'Made for Cuddles', description: 'Tagless, soft-seam designs made for all-day comfort' },
];

export const performanceBenefits = [
  { id: 1, title: 'Comfort', description: 'Soft cotton and tagless seams that feel gentle all day' },
  { id: 2, title: 'Easy Changes', description: 'Smart zips, snaps and open hems for fuss-free diaper duty' },
  { id: 3, title: 'Durability', description: 'Built to survive countless washes and still feel soft' },
  { id: 4, title: 'Sweet Style', description: 'Charming prints and keepsake pieces worth treasuring' },
];

export const steps = [
  { id: 1, title: 'Browse the Collection', description: 'Explore footies, gowns, blankets and gift sets for every little one.' },
  { id: 2, title: 'Pick Their Favorites', description: 'Choose the prints and essentials that fit your baby best.' },
  { id: 3, title: 'Secure Checkout', description: 'Safe, encrypted checkout with your payment data protected.' },
  { id: 4, title: 'Snuggle Up', description: 'Open the box and wrap your little wonder in softness.' },
];
